import { createFileRoute, redirect } from "@tanstack/react-router";
import { withQuery } from "@/lib/redirect-query";

// Legacy/menu URL — permanently redirect to the real cookie policy page.
export const Route = createFileRoute("/cookie-policy")({
  beforeLoad: ({ location }) => {
    throw redirect({ href: withQuery("/cookies/", location.searchStr), statusCode: 301 });
  },
});
